module.exports = __webpack_public_path__ + "img/9788990828699.1e50de41.jpg";